// import React from "react";
// import { IconX } from "@tabler/icons-react";
// import { UseFormWatch } from "react-hook-form";
// import { OrderFormData } from "../../../types/types";
// import { formatServiceType } from "../../../utilities/helper";

// interface PreviewModalProps {
//   onClose: () => void;
//   onBack: () => void;
//   onSubmit: React.MouseEventHandler<HTMLButtonElement>;
//   watch: UseFormWatch<OrderFormData>;
//   isSubmitting: boolean;
//   isSidebar?: boolean;
// }

// const PreviewModal: React.FC<PreviewModalProps> = ({
//   onClose,
//   onBack,
//   onSubmit,
//   watch,
//   isSubmitting,
//   isSidebar = false,
// }) => {
//   const formData = watch();

//   const formatDataForDisplay = (data: any) => {
//     return Object.entries(data).reduce((acc, [key, value]) => {
//       if (value === undefined || value === null || value === "") {
//         return acc;
//       }
//       return {
//         ...acc,
//         [key]: value,
//       };
//     }, {});
//   };

//   const senderData = formatDataForDisplay({
//     "select client": formData.clientName || "Not selected",
//     name: formData.sender?.name,
//     phone: {
//       dialCode: formData.sender?.dialCode,
//       mobile: formData.sender?.mobile,
//     },
//     email: formData.sender?.email,
//     country: formData.sender?.countryName,
//     city: formData.sender?.cityName,
//     district: formData.sender?.districtName,
//     "zip code": formData.sender?.zipCode,
//     latitude: formData.sender?.latitude,
//     longitude: formData.sender?.longitude,
//     address: formData.sender?.address,
//     "national address": formData.sender?.nationalAddress,
//   });

//   const receiverData = formatDataForDisplay({
//     name: formData.receiver?.name,
//     phone: {
//       dialCode: formData.receiver?.dialCode,
//       mobile: formData.receiver?.mobile,
//     },
//     email: formData.receiver?.email,
//     country: formData.receiver?.countryName,
//     city: formData.receiver?.cityName,
//     district: formData.receiver?.districtName,
//     "zip code": formData.receiver?.zipCode,
//     latitude: formData.receiver?.latitude,
//     longitude: formData.receiver?.longitude,
//     address: formData.receiver?.address,
//     "national address": formData.receiver?.nationalAddress,
//     "street name": formData.receiver?.streetName,
//     "building name": formData.receiver?.buildingName,
//     "building number": formData.receiver?.buildingNumber,
//   });

//   const shipmentData = formatDataForDisplay({
//     "payment mode": formData.shipment?.paymentType,
//     "cod amount":
//       formData.shipment?.paymentType === "COD"
//         ? formData.shipment?.codAmount
//         : undefined,
//     "no. pieces": formData.shipment?.numberOfPieces,
//     weight: formData.shipment?.totalWeight,
//     "reference number": formData.shipment?.referenceNumber,
//     "shipment type": formData.shipment?.shipmentType,
//     service: formatServiceType(formData.shipment?.serviceType),
//     disc: formData.shipment?.description,
//     "shipment cost": formData.shipment?.shipmentCost,
//   });

//   const PreviewSection = ({
//     title,
//     data,
//   }: {
//     title: string;
//     data: Record<string, any>;
//   }) => (
//     <div className="bg-white p-6 rounded-xl shadow-sm border w-full">
//       <h3 className="text-sm font-semibold text-gray-500 mb-4 uppercase">
//         {title}
//       </h3>
//       <div className="grid grid-cols-2 gap-3">
//         {Object.entries(data).map(([key, value]) => (
//           <div key={key} className="w-full">
//             <label className="block text-xs font-medium text-gray-600 mb-1 capitalize">
//               {key}
//             </label>
//             {key === "phone" && value?.dialCode ? (
//               <div className="flex items-center border border-[#D8D8D8] rounded-full overflow-hidden bg-white">
//                 <span className="px-2 py-2 text-gray-700 text-sm bg-white">
//                   +{value.dialCode}
//                 </span>
//                 <input
//                   disabled
//                   value={value.mobile || ""}
//                   className="flex-1 px-3 py-2 outline-none text-gray-800 text-sm bg-white border-l"
//                 />
//               </div>
//             ) : (
//               <input
//                 disabled
//                 className="bg-white w-full border border-[#D8D8D8] py-2 px-4 rounded-full text-sm"
//                 value={value as string}
//               />
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   const ShipmentField = ({
//     label,
//     value,
//   }: {
//     label: string;
//     value: string;
//   }) => (
//     <div className="w-full">
//       <label className="text-xs font-medium text-gray-600 mb-1 block capitalize">
//         {label}
//       </label>
//       <input
//         disabled
//         value={value}
//         className="bg-white w-full border border-[#D8D8D8] py-2 px-4 rounded-full text-sm"
//       />
//     </div>
//   );

//   if (isSidebar) {
//     return (
//       <div className="flex flex-col gap-4">
//         {/* STEPPER */}
//         <div className="flex my-2 space-x-2 px-2">
//           {[1, 2].map((i) => (
//             <div
//               key={i}
//               className="flex-1 border-b-4 border-[#FBD037] rounded-t-md"
//             />
//           ))}
//         </div>

//         <PreviewSection title="Sender Information" data={senderData} />
//         <PreviewSection title="Receiver Information" data={receiverData} />

//         <div className="bg-white p-4 rounded-xl shadow-md border">
//           <h2 className="text-base font-bold text-[#111111] uppercase pb-2 border-b border-gray-100 mb-2">
//             Shipment Details
//           </h2>
//           <div className="grid grid-cols-2 gap-3">
//             {Object.entries(shipmentData).map(([key, value]) => (
//               <div key={key} className="w-full">
//                 <label className="block text-xs font-medium text-slate-500 mb-1 capitalize">
//                   {key}
//                 </label>
//                 <div className="text-slate-800 text-sm font-semibold truncate bg-gray-50 border border-gray-200 rounded-xl px-3 py-1.5 min-h-[34px] flex items-center">
//                   {String(value)}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
//       <div className="bg-[#F7F6F2] rounded-lg w-[1400px] max-h-[95vh] overflow-y-auto p-6 relative shadow-xl">
//         <div className="flex justify-between items-center pb-4 border-b border-gray-200">
//           <h2 className="text-2xl font-semibold text-gray-800">
//             Order Preview
//           </h2>
//           <button className="bg-[#F2F2F7] rounded-full p-1" onClick={onClose}>
//             <IconX size={24} />
//           </button>
//         </div>

//         {/* STEPPER */}
//         <div className="flex my-4 space-x-2">
//           {[1, 2].map((i) => (
//             <div
//               key={i}
//               className="flex-1 border-b-4 border-[#FBD037] rounded-t-md"
//             />
//           ))}
//         </div>

//         <div className="grid grid-cols-2 gap-6">
//           <PreviewSection title="Sender Information" data={senderData} />
//           <PreviewSection title="Receiver Information" data={receiverData} />
//         </div>

//         <div className="mt-8">
//           <h3 className="text-sm font-semibold text-gray-500 mb-4 uppercase">
//             Shipment Details
//           </h3>
//           <div className="grid grid-cols-4 gap-4">
//             {Object.entries(shipmentData).map(([key, value]) => (
//               <ShipmentField key={key} label={key} value={value as string} />
//             ))}
//           </div>
//         </div>

//         <div className="mt-8 flex justify-end gap-3">
//           <button
//             onClick={onBack}
//             className="px-5 py-2 text-sm rounded-full border border-gray-300 hover:bg-gray-100"
//           >
//             Previous
//           </button>

//           <button
//             onClick={onSubmit}
//             disabled={isSubmitting}
//             className="px-6 py-2 text-sm font-medium bg-yellow-400 hover:bg-yellow-500 text-black rounded-full disabled:opacity-50"
//           >
//             {isSubmitting ? "Creating..." : "Create"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PreviewModal;



import React from "react";
import { IconPackage, IconUser, IconX } from "@tabler/icons-react";
import { UseFormWatch } from "react-hook-form";
import { OrderFormData } from "../../../types/types";
import ButtonStyled from "../../../components/common/ButtonStyled";
import { useLanguage } from "../../../context/LanguageContext";

interface PreviewModalProps {
  onClose: () => void;
  onBack: () => void;
  onSubmit: React.MouseEventHandler<HTMLButtonElement>;
  watch: UseFormWatch<OrderFormData>;
  isSubmitting: boolean;
  isSidebar?: boolean;
}

const PreviewModal: React.FC<PreviewModalProps> = ({
  onClose,
  onBack,
  onSubmit,
  watch,
  isSubmitting,
  isSidebar = false,
}) => {
  const { t } = useLanguage();
  const formData = watch();

  const formatDataForDisplay = (data: any) => {
    return Object.entries(data).reduce((acc, [key, value]) => {
      if (value === undefined || value === null || value === "") {
        return acc;
      }
      return {
        ...acc,
        [key]: value,
      };
    }, {});
  };

  const senderData = formatDataForDisplay({
    // "Merchant": formData.clientName || "Not selected",
    name: formData.sender?.name,
    phone: {
      dialCode: formData.sender?.dialCode,
      mobile: formData.sender?.mobile,
    },
    email: formData.sender?.email,
    country: formData.sender?.countryName,
    city: formData.sender?.cityName,
    district: formData.sender?.districtName,
    "zip code": formData.sender?.zipCode,
    latitude: formData.sender?.latitude,
    longitude: formData.sender?.longitude,
    address: formData.sender?.address,
    "national address": formData.sender?.nationalAddress,
  });

  const receiverData = formatDataForDisplay({
    name: formData.receiver?.name,
    phone: {
      dialCode: formData.receiver?.dialCode,
      mobile: formData.receiver?.mobile,
    },
    email: formData.receiver?.email,
    country: formData.receiver?.countryName,
    city: formData.receiver?.cityName,
    district: formData.receiver?.districtName,
    "zip code": formData.receiver?.zipCode,
    latitude: formData.receiver?.latitude,
    longitude: formData.receiver?.longitude,
    address: formData.receiver?.address,
    "national address": formData.receiver?.nationalAddress,
    "street name": formData.receiver?.streetName,
    "building name": formData.receiver?.buildingName,
    "building number": formData.receiver?.buildingNumber,
  });

  const shipmentData = formatDataForDisplay({
    "payment mode": formData.shipment?.paymentType,
    "cod amount":
      formData.shipment?.paymentType === "COD"
        ? formData.shipment?.codAmount
        : undefined,
    "no. pieces": formData.shipment?.numberOfPieces,
    weight: formData.shipment?.totalWeight,
    "reference number": formData.shipment?.referenceNumber,
    "shipment type": formData.shipment?.shipmentType,
    service: formData.shipment?.serviceType,
    desc: formData.shipment?.description,
    "shipment cost": formData.shipment?.shipmentCost,
  });
  const SectionHeader = ({
    
    title,
  }: {
     
    title: string;
  }) => (
    <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
     
      <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
        {t(title)}
      </p>
    </div>
  );

  const PreviewSection = ({
    title,
    data,
  }: {
    title: string;
    data: Record<string, any>;
  }) => (
    <>
      <div className="group  rounded-lg bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
        <div className="absolute inset-0 rounded-lg bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
        <SectionHeader  title={title} />

        <div className="grid grid-cols-2 gap-4">
          {Object.entries(data).map(([key, value]) => {
            const isPhone = key === "phone";
            return (
              <div key={key} className="w-full flex justify-between items-center  border rounded-xl p-2">
                <span className="font-medium text-sm text-[#212121] capitalize">
                  {t(key)} :
                </span>
                {isPhone ? (
                  <div className="flex items-center">
                    <span className="break-all text-xs">
                      {" "}
                      {typeof value === "object" && value !== null ? (
                        <>
                          {value.dialCode ? `+${value.dialCode} ` : ""}
                          {typeof value.mobile === "object" && value.mobile !== null
                            ? (value.mobile.mobile || JSON.stringify(value.mobile))
                            : (value.mobile || "")}
                        </>
                      ) : (
                        String(value || "")
                      )}
                    </span>
                  </div>
                ) : (
                  <span className="break-all text-xs">
                    {typeof value === "object" && value !== null ? JSON.stringify(value) : t(String(value || ""))}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );

  const ShipmentField = ({
    label,
    value,
  }: {
    label: string;
    value: string;
  }) => (
    <div className="group  rounded-lg bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
      <div className="absolute inset-0 rounded-lg bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      <SectionHeader  title="Shipment Details" />

      <div className="grid grid-cols-2 gap-4">
        <div className="w-full flex justify-between items-center">
          <span className="font-medium text-sm text-[#212121] capitalize">
            {t(label)} :
          </span>

          <span className="break-all text-xs">{t(value)}</span>
        </div>
      </div>
    </div>
  );

  if (isSidebar) {
    return (
      <div className="flex flex-col gap-4">
        {/* STEPPER */}
        {/* <div className="flex my-2 space-x-2 px-2">
          {[1, 2].map((i) => (
            <div
              key={i}
              className="flex-1 border-b-4 border-[#FBD037] rounded-t-md"
            />
          ))}
        </div> */}

        <PreviewSection title="Sender Information" data={senderData} />
        <PreviewSection title="Receiver Information" data={receiverData} />

        <div className="group  rounded-lg bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-lg bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader   title="Shipment Details" />

          <div className="grid grid-cols-2 gap-4">
            {Object.entries(shipmentData).map(([key, value]) => (
              <div key={key} className="flex justify-between items-center border rounded-xl p-2">
                <span className="font-medium text-sm text-[#212121] capitalize">
                  {t(key)}
                </span>
                <span className="break-all text-xs">{t(value as string)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-[#F7F6F2] rounded-lg w-[1400px] max-h-[95vh] overflow-y-auto p-6 relative shadow-xl">
        <div className="flex justify-between items-center pb-4 border-b border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800">
            {t("Order Preview")}
          </h2>
          <button onClick={onClose}>
            <IconX />
          </button>
        </div>

        {/* STEPPER */}
        <div className="flex my-4 space-x-2">
          {[1, 2].map((i) => (
            <div
              key={i}
              className="flex-1 border-b-4 border-[#FBD037] rounded-t-md"
            />
          ))}
        </div>

        <div className="grid grid-cols-2 gap-6">
          <PreviewSection title="Sender Information" data={senderData} />
          <PreviewSection title="Receiver Information" data={receiverData} />
        </div>

        <div className="mt-8">
          {Object.entries(shipmentData).map(([key, value]) => (
            <ShipmentField key={key} label={key} value={value as string} />
          ))}
        </div>

        <div className="mt-8 flex justify-end gap-3">
          <button
            onClick={onBack}
            className="px-5 py-2 text-sm rounded-full border border-gray-300 hover:bg-gray-100"
          >
            {t("Previous")}
          </button>

          <ButtonStyled
            value={t("Create")}
            onClick={onSubmit}
            isPending={isSubmitting}
          />
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
